module.exports = __webpack_public_path__ + "static/media/SUNTV_F1.c42142e2.txt";